import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { EmbryoService } from 'src/app/Services/Embryo.service';
import { TranslateService } from '@ngx-translate/core';
import { TranslationService } from 'src/app/Services/Translation/Translation.service';

@Component({
  selector: 'embryo-Features',
  templateUrl: './Features.component.html',
  styleUrls: ['./Features.component.scss']
})
export class FeaturesComponent implements OnInit {

  public shippingPriceParam = 200; //TL
  constructor(public embryoService:EmbryoService,public translate:TranslateService, public trans:TranslationService) { }

  ngOnInit() {
  }

}
